// extracted by mini-css-extract-plugin
export default {"btnToast":"toast_btnToast__nrx3P","toast":"toast_toast__O8h5B","detail":"toast_detail__ymOE6"};